<template>
  <el-container class="qq-container">
    <!-- 顶部工具栏 -->
    <el-header class="header">
      <h2 class="logo">QwQ</h2>
      <div class="header-actions">
        <el-button v-if="selectedRows.length > 0" type="danger" @click="handleBatchDelete" size="small">
          删除 ({{ selectedRows.length }})
        </el-button>
        <el-button :type="batchMode ? 'info' : 'default'" @click="toggleBatchMode" size="small">
          {{ batchMode ? '退出批量' : '批量' }}
        </el-button>
        <el-button v-if="user.username === 'askook'" type="primary" @click="showAnnouncementDialog = true" size="small">
          新增公告
        </el-button>
        <div class="user-info">
          <span>{{ user.username || '用户' }}</span>
          <el-button type="text" @click="handleLogout" size="mini">退出</el-button>
          <el-button type="text" @click="handleChangePassword" size="mini">修改密码</el-button>
        </div>
        
      </div>
    </el-header>

    <!-- 检查登录状态 -->
    <el-main v-if="!isLoggedIn" class="login-prompt">
      <el-alert title="请先登录" type="warning" show-icon />
      <el-button type="primary" @click="goToLogin" style="margin-top: 20px;">去登录</el-button>
    </el-main>

    <!-- QQ列表 -->
    <div v-else class="qq-list-container">
      <!-- 汇总卡片 -->
      <div class="summary-card">
        <div class="query-buttons">
          <el-button :disabled="queryBalanceLoading || queryAllLoading" type="success" @click="fnQueryBalanceOnly" size="small">
            只查询余额
          </el-button>
          <el-button :disabled="queryAllLoading || queryBalanceLoading" type="primary" @click="fnQueryAll" size="small">
            查询当日明细
          </el-button>
          <el-button type="warning" @click="handleCreate" size="small">添加/编辑QQ</el-button>
        </div>
        
        <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">上次汇总</span>
            <span class="stat-value">{{ lastNum }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">当前汇总</span>
            <span class="stat-value highlight">{{ allNum }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">相差</span>
            <span class="stat-value">{{ allNum ? (Number(allNum) - Number(lastNum)).toFixed(2) : '-' }}</span>
          </div>
        </div>

        <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">当日总收入</span>
            <span class="stat-value success">{{ totalTodayIncome }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">当日总支出</span>
            <span class="stat-value danger">-{{ totalTodayOutcome }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">当日汇总</span>
            <span class="stat-value" :class="Number(totalTodayNet) >= 0 ? 'success' : 'danger'">
              {{ Number(totalTodayNet) >= 0 ? '+' : '' }}{{ totalTodayNet }}
            </span>
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <!-- 搜索条件区域 -->
        <div class="search-filters">
          <div class="filter-left">
            <el-input 
              v-model="searchKeyword" 
              size="small" 
              placeholder="搜索备注/QQ号"
              clearable
              @input="handleFilterChange"
              style="width: 180px; margin-right: 10px;"
            />
            
            <el-select 
              v-if="qqList[0]?.value"
              v-model="searchStatus" 
              size="small" 
              @change="handleFilterChange"
              style="width: 120px;"
            >
              <el-option label="全部状态" value="" />
              <el-option label="正常" value="normal" />
              <el-option label="失效" value="invalid" />
              <el-option label="超时" value="timeout" />
            </el-select>

            <!-- 日期查询条件 - 移动端自适应 -->
            <div class="history-row" style="display: flex;">
              <el-date-picker
                v-model="historyDate"
                type="date"
                style="width: 160px!important; margin-right: 10px;"
                size="small"
                placeholder="选择历史日期"
                :picker-options="datePickerOptions"
                value-format="yyyy-MM-dd"
              />
              <el-button 
                size="small" 
                type="primary" 
                :disabled="queryBalanceLoading || queryAllLoading"
                @click="fnQueryHistory"
              >
                查询那天变动
              </el-button>
              <div class="device-actions">
              <el-select 
                v-model="selectedDevice" 
                size="small" 
                :placeholder="deviceList.length? `存在${deviceList.length}个设备` : '无设备'"
                clearable
                style="width: 132px; margin-left: 10px;"
              >
                <el-option v-for="d in deviceList" :key="d.id" :label="d.name" :value="d.id" />
              </el-select>
              <el-button 
                size="small" 
                type="success" 
                :loading="addDeviceLoading"
                @click="handleAddDevice"
                style="margin-left: 8px;"
              >
                添加设备
              </el-button>
              <el-button 
                v-if="selectedDevice"
                size="small" 
                type="danger" 
                plain
                @click="handleDeleteDevice"
                style="margin-left: 8px;"
              >
                删除设备
              </el-button>
              </div>
            </div>
          </div>
          
          <div class="last-query-time">
            {{ `上次查询保存时间：${formatDate(qqList[0]?.last_query_time || qqList[0]?.last_query_time)}` }}
          </div>
        </div>

        <!-- 进度条 -->
        <el-progress 
          :percentage="progressPercent" 
          :status="progressStatus"
          :stroke-width="14"
          :text-inside="true"
        />

        <el-table
          ref="multipleTable"
          :border="true"
          :row-class-name="tableRowClassName"
          size="mini"
          height="100%"
          :data="filteredList"
          style="width: 100%"
          @cell-click="fnQuery"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :header-cell-style="headerCellStyle"
          :cell-style="{ padding: '2px 0' }"
        >
          <el-table-column v-if="batchMode" type="selection" width="36" align="center" />
          <el-table-column type="index" label="#" align="center" width="36" />
          
          <el-table-column prop="avatar" align="center" label="头像" width="40">
            <template slot-scope="scope">
              <img class="avatar" :src="`https://q1.qlogo.cn/g?b=qq&nk=${scope.row.qq}&s=100`" :alt="scope.row.qq">
            </template>
          </el-table-column>
          
          <el-table-column v-if="deviceList.length > 0" prop="device" align="center" label="设备" width="80">
            <template slot-scope="scope">
              <div class="device-cell" @click.stop="openDeviceEdit(scope.row)">
                <el-select
                  v-if="scope.row._editingDevice"
                  v-model="scope.row.device"
                  size="mini"
                  placeholder="无设备"
                  clearable
                  style="width: 100%;"
                  @change="val => handleDeviceChange(scope.row, val)"
                  @blur="scope.row._editingDevice = false"
                >
                  <el-option v-for="d in deviceList" :key="d.id" :label="d.name" :value="d.name" />
                </el-select>
                <span v-else class="device-text">{{ scope.row.device || '无设备' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="title" align="center" sortable :sort-method="fnSortTitle" label="备注" min-width="80" show-overflow-tooltip class-name="ellipsis-col">
            <template slot-scope="scope">
              <div class="editable-cell" @click.stop="!batchMode && handleEdit(scope.row)">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="qq" align="center" label="QQ号" min-width="95" show-overflow-tooltip class-name="ellipsis-col">
            <template slot-scope="scope">
              <div class="editable-cell" @click.stop="copyQQ(scope.row.qq)">
                {{ scope.row.qq }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="value" label="当前余额" :sortable="!!qqList[0]?.value" :sort-method="fnSortMethods1" align="center" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.value === '失效'" class="tag tag-danger">失效</span>
              <span v-else-if="scope.row.value === '超时'" class="tag tag-warning">超时</span>
              <span v-else-if="scope.row.value" class="balance-value">{{ scope.row.value }}</span>
              <span v-else class="tag tag-default">未查</span>
            </template>
          </el-table-column>

          <el-table-column prop="last_balance" sortable :sort-method="fnSortMethods2" align="center" label="上次余额" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.last_balance === '-1.00' ? '失效' : scope.row.last_balance || '-' }}
            </template>
          </el-table-column>

          <el-table-column prop="aaaa" align="center" label="对比" min-width="60">
            <template slot-scope="scope">
              <template v-if="!scope.row.value || scope.row.value === '失效' || scope.row.value === '超时'">
                <span class="text-muted">-</span>
              </template>
              <template v-else-if="scope.row.last_balance === '-1.00'">
                <span class="text-muted">上次失效</span>
              </template>
              <template v-else>
                <span :class="Number((scope.row.value - scope.row.last_balance).toFixed(2)) >= 0 ? 'success' : 'danger'">
                  {{ Number((scope.row.value - scope.row.last_balance).toFixed(2)) === 0 ? '0' : (scope.row.value - scope.row.last_balance).toFixed(2) }}
                </span>
              </template>
            </template>
          </el-table-column>
          
          <!-- 修改：收入列 - 根据是否历史查询改变表头 -->
          <el-table-column prop="todayIncome" align="center" min-width="70" :sortable="sortAll" :sort-method="fnSortIncome">
            <template slot="header">
              <span :style="historyQueryActive ? { color: '#1890ff', fontWeight: 'bold' } : {}">
                {{ historyQueryActive ? '那天收入' : '收入' }}
              </span>
            </template>
            <template slot-scope="scope">
              <span class="success">{{ scope.row.todayIncome || '-' }}</span>
            </template>
          </el-table-column>
          
          <!-- 修改：支出列 -->
          <el-table-column prop="todayOutcome" align="center" min-width="70" :sortable="sortAll" :sort-method="fnSortOutcome">
            <template slot="header">
              <span :style="historyQueryActive ? { color: '#ff4d4f', fontWeight: 'bold' } : {}">
                {{ historyQueryActive ? '那天支出' : '支出' }}
              </span>
            </template>
            <template slot-scope="scope">
              <span class="danger">{{ scope.row.todayOutcome ? '-' + scope.row.todayOutcome : '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="todayOutcome" align="center" min-width="80" :sortable="sortAll" :sort-method="fnSortNet">
            <template slot="header">
              <span :style="historyQueryActive ? { color: '#722ed1', fontWeight: 'bold' } : {}">
                {{ historyQueryActive ? '那天变动' : '当天变动' }}
              </span>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.todayIncome" :class="Number(scope.row.todayIncome) - Number(scope.row.todayOutcome) >= 0 ? 'success' : 'danger'">
                {{ Number(Number(scope.row.todayIncome) - Number(scope.row.todayOutcome)).toFixed(2) }}
              </span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
        
          <!-- 操作列 -->
          <el-table-column :min-width="actionColWidth" align="center" fixed="right" label="操作" >
            <template slot-scope="scope">
              <div class="pc-buttons">
                <el-button size="mini" type="success" plain @click.stop="fnFz(scope.row)">复制CK</el-button>
                <el-button size="mini" plain @click.stop="fnFp(scope.row)">发票</el-button>
                <el-button size="mini" type="danger" plain @click.stop="handleDelete(scope.row)">删除</el-button>
              </div>
              <div class="mobile-dropdown" @click.stop>
                <el-dropdown 
                  trigger="click"
                  @click.stop
                  @command="(cmd) => handleAction(cmd, scope.row)"
                >
                  <el-button size="mini" type="primary" plain>
                    操作 <i class="el-icon-arrow-down el-icon--right" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="copyCk">📋 CK</el-dropdown-item>
                    <el-dropdown-item command="invoice">🧾 发票</el-dropdown-item>
                    <el-dropdown-item command="delete" divided>🗑️ 删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="80px" @submit.native.prevent>
        <!-- 编辑模式提示 - 修改这里 -->
        <div v-if="isEditMode" class="edit-tip" :class="{ 'exist-tip': parseSuccess }">
          <i :class="parseSuccess ? 'el-icon-info' : 'el-icon-warning'" />
          <span v-if="parseSuccess">解析成功，当前列表存在此QQ数据，确认备注后点击覆盖保存</span>
          <span v-else>编辑模式：仅可修改备注</span>
        </div>

        <div v-if="!isEditMode && !parseSuccess" class="import-tip">
          <i class="el-icon-info" />
          <div class="tip-content">
            <span class="tip-title">CK快捷导入</span>
            <span class="tip-text">粘贴CK自动回填，支持星悦小刀CK</span>
          </div>
        </div>

        <!-- CK导入区域 - 仅在非编辑且未成功解析时显示 -->
        <el-form-item v-if="!isEditMode && !parseSuccess">
          <div slot="label">
            <span style="color: #1890ff; font-weight: 500;">快捷导入</span>
          </div>
          <el-input ref="focusMain" v-model="cks" placeholder="粘贴CK，点击导入数据" style="margin-bottom: 20px;">
            <el-button @click="fnGet" slot="append" type="primary" style="background: #52c41a; border-color: #52c41a; color: #fff;">点击导入</el-button>
          </el-input>
        </el-form-item>
        
        <!-- CK解析成功提示 - 新增时显示 -->
        <el-alert 
          v-if="parseSuccess && !isEditMode" 
          title="CK解析成功，请确认备注后点击保存" 
          type="success" 
          show-icon 
          :closable="false"
          style="margin-bottom: 16px;"
        />
        
        <!-- 只有在需要手动输入时才显示这些字段 -->
        <template v-if="showManualInput && !isEditMode">
          <!-- 解析失败提示 -->
          <el-alert 
            v-if="parseFailed" 
            title="CK解析失败，请手动输入信息" 
            type="warning" 
            show-icon 
            :closable="false"
            style="margin-bottom: 16px;"
          />
          
          <el-form-item label="QQ备注" prop="title">
            <el-input maxlength="13" v-model="form.title" placeholder="请输入QQ备注" />
          </el-form-item>
          
          <el-form-item label="QQ号码" prop="qq">
            <el-input v-model="form.qq" maxlength="12" placeholder="请输入QQ号码" />
          </el-form-item>
          
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="openid" prop="content">
                <el-input maxlength="35" v-model="form.content" placeholder="请输入openid" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="openkey" prop="note">
                <el-input v-model="form.note" maxlength="35" placeholder="请输入openkey" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 编辑模式 或 解析成功后的只读模式 -->
        <template v-if="isEditMode || (parseSuccess && !isEditMode)">
          <!-- QQ备注可编辑 -->
          <el-form-item label="QQ备注" prop="title">
            <el-input maxlength="13" v-model="form.title" placeholder="请输入QQ备注" />
          </el-form-item>
          
          <el-divider content-position="left">qq信息</el-divider>
          <div class="readonly-info">
            <div><span class="label">QQ：</span><span>{{ form.qq }}</span></div>
            <div><span class="label">openid：</span><span class="mono">{{ form.content }}</span></div>
            <div><span class="label">openkey：</span><span class="mono">{{ form.note }}</span></div>
          </div>
        </template>
      </el-form>
      
      <!-- footer -->
      <span slot="footer" v-if="isEditMode || parseSuccess || parseFailed">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="saving">保存</el-button>
      </span>
    </el-dialog>

    <!-- 删除确认对话框 -->
    <el-dialog title="确认删除" :visible.sync="deleteDialogVisible" width="400px">
      <span>确定要删除吗？此操作不可撤销。</span>
      <span slot="footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete" :loading="deleting">确定删除</el-button>
      </span>
    </el-dialog>

    <!-- 消费记录查询对话框 -->
    <el-dialog
      class="records-dialog"
      title="消费记录"
      :visible.sync="dialogDetailShow"
      width="80%"
      :close-on-click-modal="false"
      v-loading="loading1"
      @close="handleDialogClose"
    >
      <div class="records-header">
        <div><strong>备注：</strong>{{ currentItem.title }}</div>
        <div><strong>QQ：</strong>{{ currentItem.qq }}</div>
        <div><strong>QB余额：</strong>{{ currentItem.qb }}</div>
        <div><strong>Q点余额：</strong>{{ currentItem.qd }}</div>
        <div class="date-filter">
          <el-date-picker v-model="selectedDate" type="date" placeholder="选择日期" size="mini" value-format="yyyy-MM-dd" />
          <el-button type="primary" size="mini" @click="handleQueryByDate">查询</el-button>
        </div>
      </div>
      <div class="records-header records-tip">
        <div>Q点余额已除以10，单位元。明细保持原值。</div>
      </div>
      <div v-if="dateSummary.show" class="date-summary">
        <div class="summary-title" style="display: flex; justify-content: space-between; align-items: center;">
          <div>{{ dateSummary.date }} 汇总</div>
          <el-button type="text" size="mini" @click="resetToNormalMode">返回近3个月</el-button>
        </div>
        <div class="summary-content">
          <span class="summary-item"><span class="summary-label">支出</span><span class="summary-value danger">-{{ dateSummary.totalPay }}</span></span>
          <span class="summary-item"><span class="summary-label">收入</span><span class="summary-value success">{{ dateSummary.totalSave }}</span></span>
          <span class="summary-item"><span class="summary-label">变动</span><span class="summary-value" :class="dateSummary.netChange >= 0 ? 'success' : 'danger'">{{ dateSummary.netChange >= 0 ? '+' : '' }}{{ dateSummary.netChange }}</span></span>
        </div>
      </div>

      <el-table :data="recentRecords" border stripe size="mini" style="width: 100%; margin-top: 8px;" max-height="300">
        <el-table-column prop="tranday" label="日期" width="100" align="center" />
        <el-table-column label="方式" align="center" width="55">
          <template slot-scope="scope">
            <span v-if="scope.row.accttype === '1'">Q币</span>
            <span v-if="scope.row.accttype === '3'">Q点</span>
          </template>
        </el-table-column>
        <el-table-column label="变动" align="center" width="65">
          <template slot-scope="scope">
            <span v-if="scope.row.pay" class="danger">-{{ scope.row.pay }}</span>
            <span v-if="scope.row.save" class="success">+{{ scope.row.save }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" width="70" align="center" />
        <el-table-column prop="info" label="描述" min-width="120" align="center" />
      </el-table>
      
      <div v-if="!dateSummary.show" class="pagination-info">
        <span>共 {{ count }} 条</span>
        <el-pagination 
          background 
          layout="prev, pager, next" 
          :page-size="5" 
          :pager-count="5" 
          @current-change="sizeChange" 
          :total="count" 
        />
      </div>
    </el-dialog>

    <!-- 公告发布弹窗 -->
    <el-dialog title="发布公告" :visible.sync="showAnnouncementDialog" width="70%" :close-on-click-modal="false">
      <announcement-editor :baseurl="baseurl" @announcement-created="handleAnnouncementCreated" />
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog title="修改登录密码" :visible.sync="showChangePwdDialog" width="450px" @close="pwdForm={oldPwd:'',newPwd:'',confirmPwd:''}">
      <el-form ref="pwdFormRef" :model="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="原密码" prop="oldPwd">
          <el-input v-model="pwdForm.oldPwd" show-password placeholder="输入当前登录密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="pwdForm.newPwd" show-password placeholder="设置新密码，至少6位"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPwd">
          <el-input v-model="pwdForm.confirmPwd" show-password placeholder="再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showChangePwdDialog = false">取消</el-button>
        <el-button type="primary" @click="submitChangePwd">确认修改</el-button>
      </span>
    </el-dialog>
  </el-container>
  
</template>

<script>
import axios from 'axios';
import ClipboardJS from 'clipboard'
import announcementEditor from './AnnouncementEditor.vue'

export default {
  name: 'QQManager',
  props: ['baseurl'],
  components: { announcementEditor },
  data () {
    return {
      showChangePwdDialog: false,
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      deviceList: [],
      selectedDevice: '',
      addDeviceLoading: false,
      pwdRules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: this.validateSamePwd, trigger: 'blur' }
        ]
      },
      searchKeyword: '',
      searchStatus: '',
      concurrencyLimit: 3,
      qqDisabled: false,
      showProgress: false,
      progressPercent: 0,
      progressStatus: undefined,
      sort: false,
      sortAll: false,
      search: '',
      cks: '',
      showAnnouncementDialog: false,
      allNum: 0,
      user: {},
      qqList: [],
      actionColWidth: 160,
      saving: false,
      deleting: false,
      isLoggedIn: false,
      dialogVisible: false,
      deleteDialogVisible: false,
      dialogTitle: '新增QQ',
      count: '',
      disabled: false,
      loading: false,
      loading1: false,
      loadingDetail: false,
      recentRecords: [],
      form: { id: null, title: '', qq: '', content: '', note: '' },
      dialogDetailShow: false,
      rules: {
        title: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        qq: [{ required: true, message: '请输入QQ号码', trigger: 'blur' }],
        content: [{ required: true, message: '请输入openid', trigger: 'blur' }],
        note: [{ required: true, message: '请输入openkey', trigger: 'blur' }]
      },
      currentItem: {},
      batchMode: false,
      selectedRows: [],
      tableShow: true,
      selectedDate: '',
      dateSummary: { show: false, date: '', totalPay: 0, totalSave: 0, netChange: 0 },
      originalRecords: [],
      originalCount: 0,
      totalTodayIncome: '0.00',
      totalTodayOutcome: '0.00',
      totalTodayNet: '0.00',
      queryAllLoading: false,
      queryBalanceLoading: false,
      showManualInput: false,
      parseFailed: false,
      parseSuccess: false,
      isAutoSaving: false,
      historyDate: '',
      historyQueryActive: false,
    }
  },
  computed: {
    filteredList() {
      let list = this.qqList;
      
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        list = list.filter(item => {
          const qqStr = String(item.qq || '');
          const titleStr = String(item.title || '');
          return titleStr.toLowerCase().includes(keyword) || 
                qqStr.includes(keyword);
        });
      }
      
      if (this.searchStatus) {
        list = list.filter(item => {
          const value = item.value;
          switch (this.searchStatus) {
            case 'normal':
              return value && value !== '失效' && value !== '超时' && value !== '未查询';
            case 'invalid':
              return value === '失效';
            case 'timeout':
              return value === '超时';
            default:
              return true;
          }
        });
      }
      
      return list;
    },
    lastNum() {
      if (!Array.isArray(this.qqList)) return '0.00';
      return this.qqList.reduce((sum, item) => {
        const val = Number(item.last_balance || 0);
        return sum + (val > 0 ? val : 0);
      }, 0).toFixed(2);
    },
    isEditMode() {
      return !!this.form.id;
    },
    datePickerOptions() {
      const today = new Date();
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(today.getMonth() - 6);
      
      return {
        disabledDate(time) {
          if (time.getTime() > today.getTime()) {
            return true;
          }
          if (time.getTime() < sixMonthsAgo.getTime()) {
            return true;
          }
          return false;
        }
      };
    },
    headerCellStyle() {
      if (this.historyQueryActive) {
        return {
          background: '#f0f7ff',
          color: '#1890ff',
          fontWeight: 600,
          fontSize: '14px',
          padding: '2px 0'
        };
      }
      return {
        background: '#fafafa',
        color: '#5f6368',
        fontWeight: 500,
        fontSize: '14px',
        padding: '2px 0'
      };
    }
  },
  created() {
    this.checkLoginStatus();
    const today = new Date();
    this.historyDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 校验两次新密码一致
    validateSamePwd(rule, value, callback) {
      if (value !== this.pwdForm.newPwd) {
        return callback(new Error('两次输入密码不一致'));
      }
      callback();
    },

    // 打开修改密码弹窗
    handleChangePassword() {
      this.showChangePwdDialog = true;
      // 清空表单
      this.pwdForm = { oldPwd: '', newPwd: '', confirmPwd: '' };
      this.$nextTick(() => {
        this.$refs.pwdFormRef?.clearValidate();
      });
    },

    // 提交修改密码
    async submitChangePwd() {
      try {
        await this.$refs.pwdFormRef.validate();
      } catch (err) {
        return;
      }
      try {
        const res = await fetch(`${this.baseurl}/user/password`, {
          method: 'PUT',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.pwdForm)
        });
        const data = await res.json();
        if (data.success) {
          this.$message.success(data.message);
          this.showChangePwdDialog = false;
          // 修改成功跳登录页
          this.handleLogout();
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        console.error('修改密码请求失败', err);
        this.$message.error('网络请求失败');
      }
    },

    // ====================== 工具方法 ======================
    findIndexByQQ(qq) {
      return this.qqList.findIndex(item => item.qq === qq);
    },
    
    findIndexById(id) {
      return this.qqList.findIndex(item => item.id === id);
    },

    findItemByQQ(qq) {
      return this.qqList.find(item => item.qq === qq);
    },

    findItemById(id) {
      return this.qqList.find(item => item.id === id);
    },
    // =====================================================

    handleFilterChange() {
      if (this.batchMode) {
        this.clearSelection();
      }
    },
    handleResize() {
      this.actionColWidth = window.innerWidth < 768 ? 100 : 160;
    },

    // ====================== 并发控制核心方法 ======================
    async runConcurrent(tasks, concurrency = 5, onProgress = null) {
      const total = tasks.length;
      const results = new Array(total);
      let completed = 0;
      let index = 0;
      let resolved = false;

      return new Promise((resolve, reject) => {
        const next = async () => {
          if (resolved) return;
          
          if (index >= total) {
            if (completed === total && !resolved) {
              resolved = true;
              resolve(results);
            }
            return;
          }

          const currentIndex = index++;
          try {
            const result = await tasks[currentIndex]();
            results[currentIndex] = result;
          } catch (error) {
            results[currentIndex] = { error: error.message || '任务执行失败' };
          } finally {
            completed++;
            if (onProgress) onProgress(completed, total);
            next();
          }
        };

        const workers = Math.min(concurrency, total);
        for (let i = 0; i < workers; i++) {
          next();
        }
        
        if (total === 0 && !resolved) {
          resolved = true;
          resolve(results);
        }
      });
    },
    // ==================================================================

    handleAction(cmd, row) {
      switch(cmd) {
        case 'copyCk':
          this.fnFz(row);
          break;
        case 'invoice':
          this.fnFp(row);
          break;
        case 'delete':
          this.handleDelete(row);
          break;
      }
    },

    updateProgress(current, total) {
      this.progressPercent = Math.floor((current / total) * 100);
    },
    
    startProgress(total) {
      this.showProgress = true;
      this.progressPercent = 0;
      this.progressStatus = undefined;
    },
    
    endProgress(success = true) {
      this.progressPercent = 100;
      this.progressStatus = success ? 'success' : 'exception';
    },

    fnSortMethods1(a, b) {
      const valA = isNaN(parseFloat(a.value)) ? -999999 : parseFloat(a.value);
      const valB = isNaN(parseFloat(b.value)) ? -999999 : parseFloat(b.value);
      return valA - valB;
    },

    fnSortMethods2(a, b) {
      const valA = isNaN(parseFloat(a.last_balance)) ? -999999 : parseFloat(a.last_balance);
      const valB = isNaN(parseFloat(b.last_balance)) ? -999999 : parseFloat(b.last_balance);
      return valA - valB;
    },

    fnSortIncome(a, b) {
      const valA = isNaN(parseFloat(a.todayIncome)) ? -999999 : parseFloat(a.todayIncome);
      const valB = isNaN(parseFloat(b.todayIncome)) ? -999999 : parseFloat(b.todayIncome);
      return valA - valB;
    },

    fnSortOutcome(a, b) {
      const valA = isNaN(parseFloat(a.todayOutcome)) ? -999999 : parseFloat(a.todayOutcome);
      const valB = isNaN(parseFloat(b.todayOutcome)) ? -999999 : parseFloat(b.todayOutcome);
      return valA - valB;
    },

    fnSortNet(a, b) {
      const netA = (isNaN(parseFloat(a.todayIncome)) || isNaN(parseFloat(a.todayOutcome))) ? -999999 : parseFloat(a.todayIncome) - parseFloat(a.todayOutcome);
      const netB = (isNaN(parseFloat(b.todayIncome)) || isNaN(parseFloat(b.todayOutcome))) ? -999999 : parseFloat(b.todayIncome) - parseFloat(b.todayOutcome);
      return netA - netB;
    },

    fnSortTitle(a, b) {
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
      return collator.compare(a.title || '', b.title || '');
    },

    calcTotalTodaySummary() {
      let income = 0, outcome = 0;
      this.qqList.forEach(item => {
        income += parseFloat(item.todayIncome || 0);
        outcome += parseFloat(item.todayOutcome || 0);
      });
      this.totalTodayIncome = income.toFixed(2);
      this.totalTodayOutcome = outcome.toFixed(2);
      this.totalTodayNet = (income - outcome).toFixed(2);
    },

    toggleBatchMode() {
      this.tableShow = false;
      this.batchMode = !this.batchMode;
      if (!this.batchMode) this.clearSelection();
      setTimeout(() => { this.tableShow = true }, 100);
    },
    
    handleSelectionChange(val) { this.selectedRows = val; },

    clearSelection() {
      this.$refs.multipleTable?.clearSelection();
      this.selectedRows = [];
    },
    
    async handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的项');
        return;
      }
      try {
        await this.$confirm(`确定删除选中的 ${this.selectedRows.length} 个QQ吗？`, '批量删除确认', {
          confirmButtonText: '确定删除', cancelButtonText: '取消', type: 'warning'
        });
      } catch { return; }
      
      this.loading = true;
      try {
        const response = await fetch(`${this.baseurl}/notes/batch`, {
          method: 'DELETE', credentials: 'include', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ids: this.selectedRows.map(row => row.id) })
        });
        const data = await response.json();
        if (data.success) {
          this.$message.success(data.message || `成功删除 ${data.deletedCount} 条记录`);
          this.batchMode = false;
          this.clearSelection();
          await this.loadQQList();
        } else {
          this.$message.error(data.message || '批量删除失败');
        }
      } catch (error) {
        console.error('批量删除失败:', error);
        this.$message.error('批量删除失败');
      } finally { this.loading = false; }
    },
    
    handleAnnouncementCreated() {
      this.showAnnouncementDialog = false;
      this.$message.success('公告发布成功！');
    },

    fnFz(row) {
      const ckString = `pay_openid=${row.content};pay_openkey=${row.note};pay_session_id=openid;pay_session_type=kp_accesstoken;pay_qq_nickname=${row.qq};`;
      this.copyText(ckString, `已复制 ${row.title || row.qq} 的CK`);
    },

    copyQQ(qq) {
      this.copyText(qq);
    },

    copyText(text, tip = "复制成功") {
      const btn = document.createElement('button');
      btn.dataset.clipboardText = text;
      document.body.appendChild(btn);
      const clip = new ClipboardJS(btn);
      clip.on('success', () => {
        this.$message.success(tip);
        clip.destroy();
        document.body.removeChild(btn);
      });
      clip.on('error', () => {
        this.$message.error("复制失败，请手动复制");
        clip.destroy();
        document.body.removeChild(btn);
      });
      btn.click();
    },

    hexToString(hex) {
      return decodeURIComponent(hex.replace(/(..)/g, '%$1'));
    },
    
    fnGet() {
      if (!this.cks) {
        this.$message.error('没有数据');
        return;
      }
      let str = this.cks;
      // 只有内容为纯十六进制字符（且长度为偶数）时才按 hex 解码，明文 cookie 直接解析
      if (/^[0-9a-fA-F]+$/.test(str) && str.length % 2 === 0) str = this.hexToString(str);
      this.getUrlParams(str);
    },

    async getUrlParams(targetStr) {
      let queryStr = ''
      try {
        const jsonObj = JSON.parse(targetStr)
        queryStr = jsonObj.p_ || ''
      } catch {
        queryStr = targetStr.includes(';')
          ? targetStr.replace(/;\s*/g, '&').trim()
          : targetStr.includes('?')
            ? targetStr.split('?')[1]
            : targetStr
      }

      const params = {}
      queryStr.split('&').filter(Boolean).forEach(item => {
        const equalIndex = item.indexOf('=')
        if (equalIndex > 0) {
          const key = item.substring(0, equalIndex).trim()
          const value = item.substring(equalIndex + 1).trim() || ''
          if (key) params[key] = value
        }
      })

      const openid = params.openid || params.pay_openid || ''
      const openkey = params.openkey || params.pay_openkey || ''
      const name = params.pay_qq_nickname || ''

      if (!openid || !openkey) {
        this.$message.error('数据有误，请检查');
        this.cks = '';
        this.showManualInput = true;
        this.parseFailed = true;
        this.parseSuccess = false;
        return { openid, openkey, name, apiResult: null }
      }

      this.form.content = openid;
      this.form.note = openkey;
      if(name) this.form.title = decodeURIComponent(name);

      try {
        // const res = await axios.get('/v1/r/1450000267/wechat_query', {
        const res = await axios.get('/v1/v1/r/1450000267/wechat_query', {
          params: {
            openid,
            openkey,
            session_id: 'openid',
            session_type: 'kp_accesstoken',
            cmd: 1
          }
        })

        if(res.data.ret !== 0) {
          this.$message.warning('CK解析失败，请手动输入信息');
          this.showManualInput = true;
          this.parseFailed = true;
          this.parseSuccess = false;
        } else {
          const qq = res.data.provide_uin
          const nick = res.data.nick
          this.$message.success('CK解析成功，请确认备注后点击保存');
          this.cks = '';
          
          this.form.content = openid;
          this.form.note = openkey;
          this.form.title = decodeURIComponent(nick) || name || '';
          if(qq) this.form.qq = qq
          
          const existItem = this.qqList.find(item => item.qq == this.form.qq);
          if (existItem) {
            this.form.id = existItem.id;
          }
          
          this.parseSuccess = true;
          this.parseFailed = false;
          this.showManualInput = false;
          this.qqDisabled = true;
          
          this.dialogTitle = this.form.id ? '编辑QQ' : '新增QQ';
        }
      } catch (err) {
        console.error('接口请求失败：', err)
        this.$message.warning('CK解析失败，请手动输入信息');
        this.showManualInput = true;
        this.parseFailed = true;
        this.parseSuccess = false;
        return { openid, openkey, name, apiResult: null }
      }
    },

    // ====================== 核心接口方法 ======================
    queryQQBalance(item) {
      return new Promise((resolve, reject) => {
        const callbackName = `_getQBBalance_${Date.now()}_${item.qq}`;
        const script = document.createElement('script');
        
        const timeoutId = setTimeout(() => {
          reject(new Error('腾讯API请求超时'));
          cleanup();
        }, 10000);
        
        const cleanup = () => {
          clearTimeout(timeoutId);
          delete window[callbackName];
          script.parentNode?.removeChild(script);
        };
        
        window[callbackName] = (data) => {
          let status = 'success';
          let balance = 0;
          
          if (data.ret !== 0) {
            status = 'invalid';
            balance = -1;
          } else {
            const qb = data.qb_balance || 0;
            const qd = data.qd_balance || 0;
            balance = ((qb / 100) + (qd / 100));
            status = 'success';
          }

          const targetItem = this.findItemByQQ(item.qq);
          if (targetItem) {
            if (status === 'invalid') {
              this.$set(targetItem, 'value', '失效');
            } else {
              this.$set(targetItem, 'value', balance.toFixed(2));
              this.allNum = (Number(this.allNum) + balance).toFixed(2);
            }
            targetItem._queryStatus = status;
            targetItem._balanceValue = balance;
          }

          cleanup();
          resolve({ ...data, _status: status, _balance: balance });
        };
        
        script.onerror = () => {
          cleanup();
          reject(new Error('Script load error'));
        };
        
        script.src = `https://api.unipay.qq.com/v1/r/1450000186/wechat_query?cmd=4&pf=vip_m-pay_html5-html5&pfkey=pfkey&from_h5=1&from_https=1&format=jsonp_${callbackName}&openid=${item.content}&openkey=${item.note}&session_id=openid&session_type=kp_accesstoken&qq_appid=101502376`;
        document.body.appendChild(script);
      });
    },

    queryQQTradeRecords(params) {
      return axios.get('/api/qqpay/cgi-bin/personal/account_tradeinfo.cgi', { params })
        .then(res => res.data);
    },
    // ==================================================================

    // ====================== 并发查询方法 ======================

    async fnQueryBalanceOnly() {
      this.historyQueryActive = false;
      this.allNum = 0;
      this.queryBalanceLoading = true;
      
      const totalCount = this.qqList.length;
      if (totalCount === 0) {
        this.$message.warning('暂无数据');
        this.queryBalanceLoading = false;
        return;
      }
      
      this.startProgress(totalCount);
      
      const tasks = this.qqList.map((item) => {
        return async () => {
          try {
            await Promise.race([
              this.queryQQBalance(item),
              new Promise((_, reject) => 
                setTimeout(() => reject(new Error('查询超时')), 6000)
              )
            ]);
            return { qq: item.qq, success: true };
          } catch (error) {
            console.error(`查询 ${item.qq} 失败:`, error);
            const targetItem = this.findItemByQQ(item.qq);
            if (targetItem) {
              this.$set(targetItem, 'value', '超时');
              targetItem._queryStatus = 'timeout';
            }
            return { qq: item.qq, success: false, error: error.message };
          }
        };
      });

      const results = await this.runConcurrent(
        tasks,
        this.concurrencyLimit,
        (completed, total) => {
          this.updateProgress(completed, total);
        }
      );

      const failedCount = results.filter(r => !r.success).length;
      const updates = [];
      
      this.qqList.forEach((item) => {
        if (item.id && item._queryStatus === 'success') {
          updates.push({
            id: item.id,
            balance: parseFloat(item._balanceValue)
          });
        } else if (item.id && item._queryStatus === 'invalid') {
          updates.push({
            id: item.id,
            balance: -1
          });
        }
        delete item._queryStatus;
        delete item._balanceValue;
      });

      this.queryBalanceLoading = false;
      this.endProgress(failedCount === 0);
      
      if (failedCount > 0) {
        this.$message.warning(`有 ${failedCount} 条记录查询超时`);
      }
      
      if (updates.length === 0) {
        this.$message.warning('没有需要更新的数据');
        return;
      }
      
      this.sort = true;
      
      try {
        await this.$confirm(
          `成功查询到 ${updates.length} 条记录（包含失效），是否更新？`,
          '提示',
          {
            confirmButtonText: '更新',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        const response = await fetch(`${this.baseurl}/notes/batch-balance`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ updates })
        });
        const result = await response.json();
        if (response.ok && result.success) {
          this.$message.success(`成功更新 ${result.successCount} 条记录`);
          // await this.loadQQList();
        } else {
          throw new Error(result.message || '更新失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(`更新失败: ${error.message}`);
        }
      }
    },

    async fnQueryAll() {
      this.historyQueryActive = false;
      this.allNum = 0;
      this.totalTodayIncome = '0.00';
      this.totalTodayOutcome = '0.00';
      this.totalTodayNet = '0.00';
      this.queryAllLoading = true;
        this.sortAll = true
      
      const totalCount = this.qqList.length;
      if (totalCount === 0) {
        this.$message.warning('暂无数据');
        this.queryAllLoading = false;
        return;
      }
      
      this.startProgress(totalCount);
      
      const tasks = this.qqList.map((item) => {
        return async () => {
          try {
            await Promise.all([
              Promise.race([
                this.queryQQBalance(item),
                new Promise((_, reject) => 
                  setTimeout(() => reject(new Error('余额查询超时')), 6000)
                )
              ]),
              this.getAllDayRecords(item)
            ]);
            return { qq: item.qq, success: true };
          } catch (error) {
            console.error(`查询 ${item.qq} 失败:`, error);
            const targetItem = this.findItemByQQ(item.qq);
            if (targetItem && !targetItem.value) {
              this.$set(targetItem, 'value', '超时');
              targetItem._queryStatus = 'timeout';
            }
            return { qq: item.qq, success: false, error: error.message };
          }
        };
      });

      const results = await this.runConcurrent(
        tasks,
        this.concurrencyLimit,
        (completed, total) => {
          this.updateProgress(completed, total);
        }
      );

      const failedCount = results.filter(r => !r.success).length;
      const updates = [];
      
      this.qqList.forEach((item) => {
        if (item.id && item._queryStatus === 'success') {
          updates.push({
            id: item.id,
            balance: parseFloat(item._balanceValue)
          });
        } else if (item.id && item._queryStatus === 'invalid') {
          updates.push({
            id: item.id,
            balance: -1
          });
        }
        delete item._queryStatus;
        delete item._balanceValue;
      });

      this.calcTotalTodaySummary();
      this.queryAllLoading = false;
      this.endProgress(failedCount === 0);
      
      if (failedCount > 0) {
        this.$message.warning(`有 ${failedCount} 条记录查询超时`);
      }
      
      if (updates.length === 0) {
        this.$message.warning('没有需要更新的数据');
        return;
      }
      
      this.sort = true;
      this.sortAll = true
      
      try {
        await this.$confirm(
          `成功查询到 ${updates.length} 条记录（包含失效），是否更新？`,
          '提示',
          {
            confirmButtonText: '更新',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        
        const response = await fetch(`${this.baseurl}/notes/batch-balance`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ updates })
        });
        const result = await response.json();
        if (response.ok && result.success) {
          this.$message.success(`成功更新 ${result.successCount} 条记录`);
          // await this.loadQQList();
        } else {
          throw new Error(result.message || '更新失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(`更新失败: ${error.message}`);
        }
      }
    },

    // ====================== 历史日期查询 ======================
    async fnQueryHistory() {
      this.queryBalanceLoading = true;
      
      if (!this.historyDate) {
        this.$message.warning('请先选择日期');
        return;
      }

      const selected = new Date(this.historyDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (selected.getTime() > today.getTime()) {
        this.$message.warning('不能选择未来日期');
        this.queryBalanceLoading = false;
        return;
      }

      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(today.getMonth() - 6);
      sixMonthsAgo.setHours(0, 0, 0, 0);
      
      if (selected.getTime() < sixMonthsAgo.getTime()) {
        this.$message.warning('最多只能查询6个月前的数据');
        this.queryBalanceLoading = false;
        return;
      }

      if (this.qqList.length === 0) {
        this.$message.warning('暂无数据');
        this.queryBalanceLoading = false;
        return;
      }

      this.historyQueryActive = true;
      const totalCount = this.qqList.length;
      this.startProgress(totalCount);

      try {
        const tasks = this.qqList.map((item) => {
          return async () => {
            try {
              await this.getHistoryDayRecords(item, this.historyDate);
              return { qq: item.qq, success: true };
            } catch (error) {
              console.error(`查询 ${item.qq} 历史记录失败:`, error);
              return { qq: item.qq, success: false, error: error.message };
            }
          };
        });

        const results = await this.runConcurrent(
          tasks,
          this.concurrencyLimit,
          (completed, total) => {
            this.updateProgress(completed, total);
          }
        );

        const failedCount = results.filter(r => !r.success).length;
        this.endProgress(failedCount === 0);
        this.queryBalanceLoading = false;

        if (failedCount > 0) {
          this.$message.warning(`有 ${failedCount} 条记录查询失败`);
        } else {
          this.$message.success(`成功查询 ${this.historyDate} 的历史数据`);
        }

        this.calcTotalTodaySummary();

      } catch (error) {
        console.error('历史查询失败:', error);
        this.$message.error('历史查询失败');
        this.historyQueryActive = false;
      }
    },

    async getHistoryDayRecords(item, date) {
      try {
        let pageNo = 1, hasMore = true;
        let totalSaveQb = 0;
        let totalSaveQd = 0;
        let totalPayQb = 0;
        let totalPayQd = 0;

        while (hasMore && pageNo <= 20) {
          const params = {
            coin_type: 0, 
            start_date: date, 
            end_date: date, 
            page_no: pageNo,
            channel: 'all', 
            per: 5, 
            openid: item.content, 
            openkey: item.note,
            session_id: 'openid', 
            session_type: 'kp_accesstoken', 
            qq_appid: '101502376'
          };
          const data = await this.queryQQTradeRecords(params);
          
          if (data.resultcode !== 0) break;

          const result = data.resultinfo || {};
          totalSaveQb += Number(result.saveqb || 0);
          totalSaveQd += Number(result.saveqd ? (Number(result.saveqd)/10).toFixed(2) : 0);
          totalPayQb += Number(result.payqb || 0);
          totalPayQd += Number(result.payqd ? (Number(result.payqd)/10).toFixed(2) : 0);

          hasMore = pageNo * 5 < (Number(result.count) || 0);
          pageNo++;
          if (hasMore) await new Promise(r => setTimeout(r, 30));
        }

        const totalSave = (totalSaveQb + totalSaveQd);
        const totalPay = (totalPayQb + totalPayQd);

        const targetItem = this.findItemByQQ(item.qq);
        if (targetItem) {
          this.$set(targetItem, 'todayIncome', totalSave.toFixed(2));
          this.$set(targetItem, 'todayOutcome', totalPay.toFixed(2));
        }

      } catch (err) {
        console.error(`获取 ${date} 收支失败`, err);
        const targetItem = this.findItemByQQ(item.qq);
        if (targetItem) {
          this.$set(targetItem, 'todayIncome', '0.00');
          this.$set(targetItem, 'todayOutcome', '0.00');
        }
        throw err;
      }
    },

    // ==================================================================

    async getAllDayRecords(item) {
      try {
        const now = new Date();
        const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        let pageNo = 1, hasMore = true;
        
        let totalSaveQb = 0;
        let totalSaveQd = 0;
        let totalPayQb = 0;
        let totalPayQd = 0;

        while (hasMore && pageNo <= 20) {
          const params = {
            coin_type: 0, start_date: today, end_date: today, page_no: pageNo,
            channel: 'all', per: 5, openid: item.content, openkey: item.note,
            session_id: 'openid', session_type: 'kp_accesstoken', qq_appid: '101502376'
          };
          const data = await this.queryQQTradeRecords(params);
          
          if (data.resultcode !== 0) break;

          const result = data.resultinfo || {};
          totalSaveQb += Number(result.saveqb || 0);
          totalSaveQd += Number(result.saveqd ? (Number(result.saveqd)/10).toFixed(2) : 0);
          totalPayQb += Number(result.payqb || 0);
          totalPayQd += Number(result.payqd ? (Number(result.payqd)/10).toFixed(2) : 0);

          hasMore = pageNo * 5 < (Number(result.count) || 0);
          pageNo++;
          if (hasMore) await new Promise(r => setTimeout(r, 30));
        }

        const totalSave = (totalSaveQb + totalSaveQd);
        const totalPay = (totalPayQb + totalPayQd);

        const targetItem = this.findItemByQQ(item.qq);
        if (targetItem) {
          this.$set(targetItem, 'todayIncome', totalSave.toFixed(2));
          this.$set(targetItem, 'todayOutcome', totalPay.toFixed(2));
        }

      } catch (err) {
        console.error('获取当天收支失败', err);
        const targetItem = this.findItemByQQ(item.qq);
        if (targetItem) {
          this.$set(targetItem, 'todayIncome', '0.00');
          this.$set(targetItem, 'todayOutcome', '0.00');
        }
      }
    },

    tableRowClassName({ row }) {
      if (row.value === '失效') return 'invalid-row';
      if (row.value === '超时') return 'timeout-row';
      return 'valid-row';
    },
    
    async checkLoginStatus() {
      try {
        const response = await fetch(`${this.baseurl}/check`, { method: 'GET', credentials: 'include' });
        const data = await response.json();
        if (data.success) {
          this.user = data.user;
          this.isLoggedIn = true;
          this.loadQQList();
        } else {
          this.handleLogout();
        }
      } catch (error) {
        console.error('检查登录状态失败:', error);
        this.handleLogout();
      }
    },
    
    // ====================== 设备接口方法 ======================
    async loadDevices() {
      try {
        const response = await fetch(`${this.baseurl}/devices`, { method: 'GET', credentials: 'include' });
        const data = await response.json();
        if (data.success) {
          this.deviceList = data.data || [];
        }
      } catch (error) {
        console.error('加载设备列表失败:', error);
      }
    },

    handleAddDevice() {
      this.$prompt('请输入设备名称（最多5个字）', '添加设备', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '设备名称',
        inputValidator: (value) => {
          if (!value || !String(value).trim()) return '设备名称不能为空';
          if (String(value).trim().length > 5) return '设备名称最多5个字';
          return true;
        }
      }).then(async ({ value }) => {
        const name = String(value).trim();
        this.addDeviceLoading = true;
        try {
          const response = await fetch(`${this.baseurl}/devices`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name })
          });
          const data = await response.json();
          if (data.success) {
            this.$message.success(data.message || '设备添加成功');
            // 重新查询设备列表，不刷新页面
            await this.loadDevices();
          } else {
            this.$message.error(data.message || '添加设备失败');
          }
        } catch (error) {
          console.error('添加设备失败:', error);
          this.$message.error('添加设备失败');
        } finally {
          this.addDeviceLoading = false;
        }
      }).catch(() => {});
    },
    handleDeleteDevice() {
      if (!this.selectedDevice) return;
      const device = this.deviceList.find(d => d.id === this.selectedDevice);
      this.$confirm(`确定删除设备"${device ? device.name : ''}"吗？删除后列表将刷新并且永远失去这个设备。。。`, '删除设备', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await fetch(`${this.baseurl}/devices/${this.selectedDevice}`, {
            method: 'DELETE',
            credentials: 'include'
          });
          const data = await response.json();
          if (data.success) {
            this.$message.success(data.message || '设备删除成功');
            this.selectedDevice = '';
            await this.loadDevices();
            await this.loadQQList();
          } else {
            this.$message.error(data.message || '删除设备失败');
          }
        } catch (error) {
          console.error('删除设备失败:', error);
          this.$message.error('删除设备失败');
        }
      }).catch(() => {});
    },

    // 点击设备单元格进入编辑态（显示select）
    openDeviceEdit(row) {
      this.$set(row, '_editingDevice', true);
    },

    // 单行设备字段更新（选择即提交，只更新设备字段）
    async handleDeviceChange(row, val) {
      const oldVal = row.device;
      const deviceVal = val || '';
      try {
        const response = await fetch(`${this.baseurl}/notes/${row.id}`, {
          method: 'PUT',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ device: deviceVal })
        });
        const data = await response.json();
        if (data.success) {
          this.$message.success('当前QQ的仅设备已更新');
        } else {
          this.$set(row, 'device', oldVal);
          this.$message.error('当前QQ设备更新失败');
        }
        this.$set(row, '_editingDevice', false);
      } catch (error) {
        console.error('更新设备失败:', error);
        this.$set(row, 'device', oldVal);
        this.$message.error('当前QQ设备更新失败');
      }
    },
    // ============================================================

    async loadQQList() {
      this.loading = true;
      this.historyQueryActive = false;
      try {
        const response = await fetch(`${this.baseurl}/notes`, { method: 'GET', credentials: 'include' });
        const data = await response.json();
        if (data.success) {
          this.qqList = data.data;
          this.isLoggedIn = true;
          this.loadDevices();
        } else if (data.message === '请先登录') {
          this.handleLogout();
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
      } finally { this.loading = false; }
    },
    
    handleCreate() {
      this.dialogTitle = '新增QQ';
      this.form = { id: null, title: '', qq: '', content: '', note: '' };
      this.showManualInput = false;
      this.parseFailed = false;
      this.parseSuccess = false;
      this.cks = '';
      this.qqDisabled = false;
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.formRef?.clearValidate());
    },
    
    async fnQuery(row) {
      this.loading = true;
      this.currentItem = row;
      this.dateSummary.show = false;
      this.selectedDate = '';
      
      const res = await this.loadRecentRecords(1, row.content, row.note);
      if (res.resultcode !== 0) {
        this.$message.error('QQ已过期');
      } else {
        try {
          const result = await Promise.race([
            this.queryQQBalance(this.currentItem),
            new Promise((_, reject) => setTimeout(() => reject(new Error('超时')), 10000))
          ]);
          
          if (result._status === 'invalid') {
            this.$set(row, 'value', '失效');
            // 保存失效状态到数据库
            if (row.id) {
              try {
                await fetch(`${this.baseurl}/notes/${row.id}`, {
                  method: 'PUT',
                  credentials: 'include',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ balance: -1 })
                });
              } catch (e) {
                console.error('保存失效状态失败:', e);
              }
            }
          } else if (result._status === 'success') {
            this.$set(row, 'value', result._balance.toFixed(2));
          }
        } catch (error) {
          console.error('查询余额失败:', error);
          this.$set(row, 'value', '超时');
        }
        
        const ret = res.resultinfo;
        this.count = Number(ret.count);
        this.dialogDetailShow = true;
        this.recentRecords = ret.list;
      }
      this.loading = false;
    },

    async sizeChange(pageNo) {
      if (this.dateSummary.show) return;
      this.loading1 = true;
      try {
        const res = await this.loadRecentRecords(pageNo, this.currentItem.content, this.currentItem.note);
        this.recentRecords = res.resultinfo.list;
      } catch (error) {
        this.$message.error('加载记录失败');
      } finally { this.loading1 = false; }
    },
    
    async loadRecentRecords(pageNo, openid, openkey) {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 3);
      
      const formatDate = (d) => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
          
      const params = {
        coin_type: 0, start_date: formatDate(startDate), end_date: formatDate(endDate),
        page_no: pageNo, channel: 'all', per: 5, extcode: '', t: Math.random(),
        openid, openkey, session_id: 'openid', session_type: 'kp_accesstoken', qq_appid: '101502376'
      };
      return this.queryQQTradeRecords(params);
    },
    
    async handleQueryByDate() {
      if (!this.selectedDate) {
        this.$message.warning('请先选择日期');
        return;
      }
      
      this.loading1 = true;
      if (!this.dateSummary.show) {
        this.originalRecords = [...this.recentRecords];
        this.originalCount = this.count;
      }
      
      try {
        this.dateSummary = { show: true, date: this.selectedDate, totalPay: 0, totalSave: 0, netChange: 0 };
        let allRecords = [], pageNo = 1, hasMore = true;

        let totalSaveQb = 0;
        let totalSaveQd = 0;
        let totalPayQb = 0;
        let totalPayQd = 0;

        while (hasMore) {
          const params = {
            coin_type: 0, start_date: this.selectedDate, end_date: this.selectedDate,
            page_no: pageNo, channel: 'all', per: 5, extcode: '', t: Math.random(),
            openid: this.currentItem.content, openkey: this.currentItem.note,
            session_id: 'openid', session_type: 'kp_accesstoken', qq_appid: '101502376'
          };
          const data = await this.queryQQTradeRecords(params);
          
          if (data.resultcode !== 0) break;
          
          const result = data.resultinfo || {};
          const list = result.list || [];
          allRecords = [...allRecords, ...list];
          
          totalSaveQb += Number(result.saveqb || 0);
          totalSaveQd += Number(result.saveqd ? (Number(result.saveqd)/10).toFixed(2) : 0);
          totalPayQb += Number(result.payqb || 0);
          totalPayQd += Number(result.payqd ? (Number(result.payqd)/10).toFixed(2) : 0);
          
          hasMore = pageNo * 5 < (Number(result.count) || 0);
          pageNo++;
          if (hasMore) await new Promise(r => setTimeout(r, 100));
        }
        
        const totalSave = (totalSaveQb + totalSaveQd);
        const totalPay = (totalPayQb + totalPayQd);

        this.dateSummary.totalSave = totalSave.toFixed(2);
        this.dateSummary.totalPay = totalPay.toFixed(2);
        this.dateSummary.netChange = (totalSave - totalPay).toFixed(2);
        
        this.recentRecords = allRecords;
        this.count = allRecords.length;
        
        if (allRecords.length === 0) this.$message.info('所选日期无消费记录');
        else this.$message.success(`共查询到 ${allRecords.length} 条记录`);
      } catch (error) {
        this.$message.error('查询失败');
      } finally {
        this.loading1 = false;
      }
    },
    
    resetToNormalMode() {
      this.dateSummary.show = false;
      this.recentRecords = this.originalRecords;
      this.count = this.originalCount;
      this.selectedDate = '';
      this.originalRecords = [];
      this.originalCount = 0;
    },
    
    handleDialogClose() {
      this.recentRecords = [];
      this.count = 0;
      this.dialogDetailShow = false;
      this.dateSummary.show = false;
      this.selectedDate = '';
    },
    
    handleEdit(item) {
      this.dialogTitle = '编辑备注';
      this.form = { 
        id: item.id, 
        title: item.title, 
        qq: item.qq, 
        content: item.content, 
        note: item.note 
      };
      this.showManualInput = false;
      this.parseFailed = false;
      this.parseSuccess = false;
      this.dialogVisible = true;
    },
    
    async handleSubmit() {
      if (!this.form.title.trim()) {
        this.$message.warning('请输入备注');
        return;
      }

      if (this.parseSuccess && !this.isEditMode) {
        if (!this.form.qq || !this.form.content || !this.form.note) {
          this.$message.warning('数据不完整，请重新导入');
          return;
        }
      }

      if (!this.form.id) {
        const existItem = this.qqList.find(item => item.qq == this.form.qq);
        if (existItem) {
          try {
            await this.$confirm(
              `QQ号 ${this.form.qq} 已存在，是否覆盖？`,
              '数据重复',
              {
                confirmButtonText: '覆盖',
                cancelButtonText: '取消',
                type: 'warning'
              }
            );
            this.form.id = existItem.id;
          } catch (err) {
            return;
          }
        }
      }

      this.saving = true;
      try {
        if (this.form.id) {
          const response = await fetch(`${this.baseurl}/notes/${this.form.id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
              title: this.form.title,
              content: this.form.content,
              note: this.form.note,
              qq: this.form.qq
            })
          });
          const data = await response.json();
          if (data.success) {
            this.$message.success('更新成功');
            this.dialogVisible = false;
            this.parseSuccess = false;
            this.parseFailed = false;
            this.showManualInput = false;
            this.cks = '';
            await this.loadQQList();
          } else {
            this.$message.error(data.message || '更新失败');
          }
        } else {
          const response = await fetch(`${this.baseurl}/notes`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              title: this.form.title,
              content: this.form.content,
              note: this.form.note,
              qq: this.form.qq
            })
          });
          const data = await response.json();
          if (data.success) {
            this.$message.success('新增成功');
            this.dialogVisible = false;
            this.parseSuccess = false;
            this.parseFailed = false;
            this.showManualInput = false;
            this.cks = '';
            await this.loadQQList();
          } else {
            this.$message.error(data.message || '新增失败');
          }
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败');
      } finally {
        this.saving = false;
      }
    },

    handleDelete(item) {
      this.currentItem = item;
      this.deleteDialogVisible = true;
    },
    
    fnFp(row) {
      const url = `https://pay.qq.com/h5/invoice/index.shtml?wxAppid2=wx951bdcac522929b6&sessionid=openid&sessiontype=kp_accesstoken&uin=${row.qq}&openid=${row.content}&openkey=${row.note}#/`;
      window.open(url, '_blank');
    },
    
    async confirmDelete() {
      this.deleting = true;
      try {
        const response = await fetch(`${this.baseurl}/notes/${this.currentItem.id}`, { method: 'DELETE', credentials: 'include' });
        const data = await response.json();
        if (data.success) {
          this.$message.success('删除成功');
          this.deleteDialogVisible = false;
          this.loadQQList();
        } else {
          this.$message.error(data.message || '删除失败');
        }
      } catch (error) {
        this.$message.error('删除失败');
      } finally {
        this.deleting = false;
        this.deleteDialogVisible = false;
        this.currentItem = {};
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    
    async handleLogout() {
      try {
        await fetch(`${this.baseurl}/logout`, { method: 'POST', credentials: 'include' });
      } catch (error) {
        console.error('退出登录失败:', error);
      }
      localStorage.removeItem('user');
      this.isLoggedIn = false;
      this.$emit('logout');
    },
    
    goToLogin() { this.$emit('logout'); }
  }
}
</script>



<style>
/* ==================== 全局重置 ==================== */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.qq-container {
  height: 100vh;
  background: #f7f8fa;
  overflow: hidden;
}

/* ==================== 表格行样式 ==================== */
.el-table .invalid-row {
  background-color: #fff2f2;
}
.el-table .timeout-row {
  background-color: #fffbf0;
}
.el-table .valid-row {
  background-color: #ffffff;
}

/* ==================== 通用工具类 ==================== */
.success {
  color: #00b42a !important;
}
.danger {
  color: #f53f3f !important;
}
.highlight {
  color: #1677ff !important;
  font-weight: 600;
}
.text-muted {
  color: #c0c4cc !important;
}
.mono {
  font-size: 14px;
  word-break: break-all;
}

/* ==================== 标签 ==================== */
.tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}
.tag-danger {
  background: #f53f3f;
  color: #fff;
}
.tag-warning {
  background: #ff7d00;
  color: #fff;
}
.tag-default {
  background: #e5e6eb;
  color: #86909c;
}

/* ==================== 余额数值 ==================== */
.balance-value {
  color: #1677ff;
  font-weight: 600;
}

/* ==================== 可编辑单元格 ==================== */
.editable-cell {
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.2s ease;
  text-decoration: underline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.editable-cell:hover {
  background: #e8f3ff;
}

/* ==================== 设备单元格 ==================== */
.device-cell {
  cursor: pointer;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.device-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
}
.device-cell:hover .device-text {
  color: #409eff;
  text-decoration: underline;
}

/* ==================== 滚动条 ==================== */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f2f3f5;
}
::-webkit-scrollbar-thumb {
  background: #d0d3d9;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b4b9c3;
}

/* ==================== 进度条文字 ==================== */
.el-progress-bar__innerText {
  color: #fff !important;
  font-weight: 500;
  font-size: 14px;
}

/* ==================== 表格全局统一居中 + 紧凑简约 ==================== */
.el-table {
  font-size: 14px;
  border-radius: 6px;
}
/* 表头全部居中 */
.el-table th.el-table__cell {
  text-align: center !important;
  padding: 0 !important;
  background: #f2f3f5 !important;
  line-height: 36px;
}
/* 单元格全部居中 */
.el-table .cell {
  text-align: center !important;
  padding: 0 4px !important;
  line-height: 30px!important;
  height: 30px;
  font-size: 14px;
}
.ellipsis-col .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.el-table th.el-table__cell > .cell {
  padding: 0 4px !important;
}
.el-table .avatar {
  margin: 0 auto;
}

/* ==================== 按钮紧凑简约 ==================== */
.el-button--mini {
  padding: 2px 6px;
  font-size: 13px;
}
.el-button--small {
  padding: 4px 10px;
  font-size: 14px;
}
</style>

<style scoped>
/* ==================== 头部 ==================== */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e5e6eb;
  height: 50px;
  flex-shrink: 0;
}

.logo {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1677ff;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 12px;
  border-left: 1px solid #e5e6eb;
}
.user-info span {
  color: #4e5969;
  font-size: 14px;
}

/* ==================== 登录提示 ==================== */
.login-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 50px);
  gap: 16px;
}

/* ==================== 主容器 ==================== */
.qq-list-container {
  padding: 10px 16px;
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
}

.table-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ==================== 汇总卡片 简约风 ==================== */
.summary-card {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  border: 1px solid #e5e6eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  flex-shrink: 0;
}

.query-buttons {
  display: flex;
  gap: 8px;
}

.summary-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.stat-label {
  font-size: 13px;
  color: #86909c;
  margin-bottom: 2px;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

/* ==================== 搜索区域 ==================== */
.search-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.filter-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.last-query-time {
  font-size: 14px;
  color: #86909c;
  white-space: nowrap;
}

/* ==================== 头像 ==================== */
.avatar {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: block;
}

/* ==================== 弹窗提示区块 ==================== */
.edit-tip {
  background: #fffbe6;
  border-left: 3px solid #ff7d00;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #ff7d00;
}

.readonly-info {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  color: #4e5969;
}
.readonly-info div {
  padding: 2px 0;
}
.readonly-info .label {
  font-weight: 500;
  color: #1d2129;
  display: inline-block;
  width: 100px;
}

.import-tip {
  background: #e8f3ff;
  border-left: 3px solid #1677ff;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.import-tip i {
  font-size: 16px;
  color: #1677ff;
}
.tip-content {
  flex: 1;
}
.tip-title {
  font-size: 14px;
  font-weight: 500;
  color: #1677ff;
}
.tip-text {
  font-size: 14px;
  color: #4e5969;
  margin-left: 6px;
}

/* ==================== 操作列响应式 ==================== */
@media (max-width: 1000px) {
  .pc-buttons {
    display: none;
  }
  .mobile-dropdown {
    display: block;
  }
}
@media (min-width: 1001px) {
  .mobile-dropdown {
    display: none;
  }
}

/* ==================== 消费记录弹窗 ==================== */
.records-dialog .el-dialog__body {
  padding: 12px 16px;
}

.records-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
  background: #f7f8fa;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: 14px;
}
.records-tip {
  background: #e8f3ff;
  color: #4e5969;
}

.date-filter {
  display: flex;
  gap: 8px;
}

/* ==================== 日期汇总区块 ==================== */
.date-summary {
  background: #e8f3ff;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 10px 0;
  border: 1px solid #c6e0ff;
}

.summary-title {
  font-size: 13px;
  font-weight: 600;
  color: #1677ff;
  margin-bottom: 6px;
}

.summary-content {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 13px;
}
.summary-label {
  color: #4e5969;
}
.summary-value {
  font-weight: 600;
  font-family: monospace;
}

/* ==================== 分页区域 ==================== */
.pagination-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  font-size: 13px;
  color: #86909c;
}

/* ==================== 移动端适配 ==================== */
@media (max-width: 768px) {
  .summary-card {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 10px 12px;
  }
  .query-buttons {
    justify-content: center;
  }
  .summary-stats {
    justify-content: space-around;
  }
  .stat-item {
    align-items: center;
  }
  .stat-value {
    font-size: 14px;
  }
  .search-filters {
    flex-direction: column;
    align-items: stretch;
  }
  .filter-left {
    flex-direction: column;
    align-items: stretch;
  }
  .filter-left .el-input,
  .filter-left .el-select {
    width: 100%!important;
  }
  .history-row {
    flex-wrap: wrap;
  }
  .device-actions {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 4px;
  }
  .device-actions .el-select {
    flex: 1;
    width: auto!important;
    margin-left: 0!important;
    min-width: 0;
  }
  .device-actions .el-button {
    flex-shrink: 0;
  }

  .last-query-time {
    text-align: center;
    font-size: 14px;
  }
  .header {
    padding: 0 12px;
    height: 46px;
  }
  .logo {
    font-size: 16px;
  }
  .qq-list-container {
    padding: 8px;
    height: calc(100vh - 46px);
  }
}
</style>